/**
 * @generated SignedSource<<7d6deeba4be15d3409c86a64c52f6efb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RepositoryPickerRepositoryIssueTemplates$data = {
  readonly contactLinks: ReadonlyArray<{
    readonly __typename: "RepositoryContactLink";
    readonly __id: string;
    readonly about: string;
    readonly name: string;
    readonly url: string;
  }> | null;
  readonly isBlankIssuesEnabled: boolean;
  readonly isSecurityPolicyEnabled: boolean | null;
  readonly issueForms: ReadonlyArray<{
    readonly __typename: "IssueForm";
    readonly __id: string;
    readonly assignees: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"AssigneePickerAssignee">;
        } | null;
      } | null> | null;
      readonly totalCount: number;
    };
    readonly description: string | null;
    readonly filename: string;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"LabelPickerLabel">;
        } | null;
      } | null> | null;
      readonly totalCount: number;
    } | null;
    readonly name: string;
    readonly projects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"ProjectPickerProject">;
        } | null;
      } | null> | null;
    };
    readonly title: string | null;
    readonly type: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"IssueFormElements_templateElements">;
  }> | null;
  readonly issueTemplates: ReadonlyArray<{
    readonly __typename: "IssueTemplate";
    readonly __id: string;
    readonly about: string | null;
    readonly assignees: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"AssigneePickerAssignee">;
        } | null;
      } | null> | null;
      readonly totalCount: number;
    };
    readonly body: string | null;
    readonly filename: string;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"LabelPickerLabel">;
        } | null;
      } | null> | null;
      readonly totalCount: number;
    } | null;
    readonly name: string;
    readonly title: string | null;
    readonly type: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
    } | null;
  }> | null;
  readonly securityPolicyUrl: string | null;
  readonly templateTreeUrl: string;
  readonly " $fragmentType": "RepositoryPickerRepositoryIssueTemplates";
};
export type RepositoryPickerRepositoryIssueTemplates$key = {
  readonly " $data"?: RepositoryPickerRepositoryIssueTemplates$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryPickerRepositoryIssueTemplates">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "RepositoryPickerRepositoryIssueTemplates"
};

(node as any).hash = "e80fbaec2adb2595ece108ec7e011688";

export default node;
